// The `QuestionAnswer` component displays a FAQ item consisting of a question and its
// corresponding answer. The question is rendered as bold text, while the answer is
// dynamically displayed by iterating through an array of answer segments.
// If a segment is highlighted, it either shows as a link (if a URL is provided) or
// as bold text. Regular answer segments are displayed as plain text. The component
// is styled with Tailwind CSS for consistent formatting and layout.

const QuestionAnswer = ({
  question,
  answer,
}: {
  question: string;
  answer: { text: string; highlight: boolean; link?: string }[];
}) => {
  return (
    <div className="faq-item my-20 border-b pb-20">
      <p className="question text-18 font-bold leading-7">{question}</p>
      <p className="answer text-16 font-normal leading-7 tracking-wide">
        {answer?.map((segment, index) => {
          if (segment?.highlight) {
            return segment?.link ? (
              <a
                key={index}
                href={segment?.link}
                className="highlighted-link cursor-pointer pe-3 ps-3 font-bold text-[#1dce8f] underline hover:text-[#1dce8f]"
                target="_blank"
                rel="noopener noreferrer"
              >
                {segment?.text}
              </a>
            ) : (
              <span key={index} className="highlighted-text pe-1 ps-1">
                {segment?.text}
              </span>
            );
          }
          return <span key={index}>{segment?.text}</span>;
        })}
      </p>
    </div>
  );
};

export default QuestionAnswer;
